import React, { useState } from "react";
import Menu from "../Menu";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import useApiUrls from "../../useApiUrls";
import SuccessMessage from "../../components/successMessage";
import FailedMessage from "../../components/FailedMessage";

const AndroidList = () => {
  const navigate = useNavigate();
  const { getUrlByOperation } = useApiUrls();

  // State to hold form data
  const [formData, setFormData] = useState({
    version: "1",
    file: null,
  });

  // State to hold API response or error
  const [message, setMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    
    console.log("Form submitted"); // Debug log

    const token = getCookie("token");
    const userid = getCookie("userid");

    console.log("Token:", token ? "exists" : "missing"); // Debug log
    console.log("UserID:", userid ? "exists" : "missing"); // Debug log

    if (!token || !userid) {
      console.error("Missing token or userId in cookies");
      setMessage("Failed to upload file.");
      return;
    }

    if (!formData.file) {
      console.log("No file selected"); // Debug log
      setMessage("Please select a file to upload.");
      return;
    }

    console.log("File selected:", formData.file.name); // Debug log
    console.log("Version:", formData.version); // Debug log

    // Create FormData for multipart/form-data
    const dataToSend = new FormData();
    dataToSend.append("Version", formData.version);
    dataToSend.append("File", formData.file);

    setIsLoading(true);

    try {
      // Get the URL
      const uploadFileUrl = getUrlByOperation("UploadFile");
      console.log("API URL:", uploadFileUrl); // Debug log - CHECK THIS!

      // If getUrlByOperation doesn't work, use the direct URL as fallback
      const apiUrl = uploadFileUrl || "https://api.dqr-display-tms.eventum.co.in/api/UploadFile/DisplayHtmlPol";
      
      console.log("Making API call to:", apiUrl); // Debug log

      const response = await axios.post(apiUrl, dataToSend, {
        headers: {
          "X-Authorization": token,
          "UserId": userid,
          "accept": "text/plain",
          // Don't set Content-Type manually for FormData, axios handles it
        },
      });

      console.log("API Response:", response); // Debug log
      setMessage("File uploaded successfully!");
      setIsLoading(false);

      // Clear message and reset form after 3 seconds
      setTimeout(() => {
        setMessage("");
        setFormData({ version: "1", file: null });
      }, 3000);
    } catch (error) {
      console.error("Upload error - Full error:", error); // Debug log
      console.error("Error response:", error.response); // Debug log
      console.error("Error message:", error.message); // Debug log
      
      setMessage(`Failed to upload file. ${error.response?.data || error.message}`);
      setIsLoading(false);
    }
  };

  // Handle input change for text inputs
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  // Handle file input change
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    console.log("File selected:", file); // Debug log
    setFormData((prevData) => ({
      ...prevData,
      file: file,
    }));
  };

  return (
    <>
      <Menu />
      <div className="wrapper">
        <div className="content-wrapper">
          <section className="content-header">
            <div className="container-fluid">
              <div className="row mb-2">
                <div className="col-sm-6">
                  <h1>Upload Android File</h1>
                </div>
              </div>
            </div>
          </section>
          <section className="content">
            <div className="container-fluid">
              <div className="row">
                <div className="col-md-12">
                  <div className="card card-info">
                    <div className="card-header">
                      <h3 className="card-title">Upload File</h3>
                    </div>
                    <div className="card-body">
                      <form id="upload-file-form" onSubmit={handleSubmit}>
                        <div className="row">
                          <div className="col-sm-6">
                            <div className="form-group">
                              <label>Version</label>
                              <input
                                type="text"
                                className="form-control"
                                value={formData.version}
                                onChange={handleChange}
                                placeholder="Enter version (default: 1)..."
                                name="version"
                              />
                            </div>
                          </div>
                          <div className="col-sm-6">
                            <div className="form-group">
                              <label>Select File</label>
                              <input
                                type="file"
                                className="form-control"
                                onChange={handleFileChange}
                                name="file"
                              />
                              {formData.file && (
                                <small className="form-text text-muted">
                                  Selected: {formData.file.name}
                                </small>
                              )}
                            </div>
                          </div>
                        </div>

                        <div className="form-footer">
                          <button
                            type="submit"
                            id="upload-btn"
                            className="btn btn-info"
                            disabled={isLoading}
                          >
                            {isLoading ? "Uploading..." : "Upload"}
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>

      {message === "File uploaded successfully!" && (
        <SuccessMessage 
          message={message} 
          onClose={() => setMessage("")}
        />
      )}

      {message && message !== "File uploaded successfully!" && (
        <FailedMessage message={message} onClose={() => setMessage("")} />
      )}
    </>
  );
};

export default AndroidList;

function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(";").shift();
}